<
<template>
  <div>
    <component-header
      title="Notification Approval Details"
      :hasSearch="false"
      :hasReload="false"
      :hasCreate="false"
      :hasback="true"
      @back-press="$router.push('/approvalNotification')"
    />
    <b-card>
      <div>
        <h4 style="text-align: right">
          Status :
          <span
            class="span-text"
            v-if="bulkNotificationData.status == 'APPROVED'"
            style="color: green; font-weight: 800"
            >{{ bulkNotificationData.status }}</span
          >
          <span
            class="span-text"
            v-if="bulkNotificationData.status == 'REJECTED'"
            style="color: red; font-weight: 800"
            >{{ bulkNotificationData.status }}</span
          >
          <span
            class="span-text"
            v-if="bulkNotificationData.status == 'PENDING'"
            style="color: blue; font-weight: 800"
            >{{ bulkNotificationData.status }}</span
          >
        </h4>
      </div>
      <div>
        <b-row>
          <b-col md="8" class="pb-0"
            ><h4 class="mx-3" style="color: #727cf5">Filter Criteria</h4></b-col
          >
          <b-col md="4" class="pb-0"
            ><h4 class="mx-3" style="color: #727cf5">Search Criteria</h4></b-col
          >
        </b-row>
        <b-row class="mt-0">
          <b-col md="5">
            <div class="mx-3">
              <h5 class="h5-text">
                Created Date :
                <span class="span-text">{{
                  bulkNotificationData.createdAt | formatedate
                }}</span>
              </h5>
              <h5 class="h5-text">
                Collection Name :
                <span class="span-text">{{
                  bulkNotificationData && bulkNotificationData.criteria
                    ? bulkNotificationData.criteria.collectionName
                    : ""
                }}</span>
              </h5>
              <h5 class="h5-text">
                Count :
                <span class="span-text">{{
                  bulkNotificationData && bulkNotificationData.criteria
                    ? bulkNotificationData.criteria.count
                    : ""
                }}</span>
              </h5>
              <h5 class="h5-text">
                Status :
                <span class="span-text">{{
                  bulkNotificationData && bulkNotificationData.criteria
                    ? bulkNotificationData.criteria.status
                    : ""
                }}</span>
              </h5>
              <h5 class="h5-text">
                URL :
                <span class="span-text">
                  <a
                    v-bind:href="
                      bulkNotificationData && bulkNotificationData.criteria
                        ? bulkNotificationData.criteria.url
                        : ''
                    "
                    class="btn btn-primary ml-2"
                    >Download</a
                  >
                </span>
              </h5>
            </div>
          </b-col>
          <b-col md="7">
            <b-table
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive="sm"
              :items="approvalNotificationFilter"
              :fields="criteriaColumns"
              thead-class="header"
              show-empty
            >
              <template #cell(name)="data">
                <b class="text-info">{{ data.value.last.toUpperCase() }}</b
                >, <b>{{ data.value.first }}</b>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <hr style="border-top: 1px dashed #727cf5" class="mt-2 my-3" />
        <h4 class="mx-3" style="color: #727cf5">Template Configuration</h4>
        <b-row>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                Description :
                <span class="span-text">{{
                  bulkNotificationData.description
                }}</span>
              </h5>
              <h5 class="h5-text">
                Notification Type :
                <span class="span-text">{{
                  bulkNotificationData.notificationType
                }}</span>
              </h5>
              <h5 class="h5-text">
                Schedule Date & Time :
                <span class="span-text">{{
                  bulkNotificationData.scheduleDate | formateScheduleDate
                }}</span>
              </h5>
              <h5 class="h5-text">
                Scheduler Status :
                <span class="span-text">{{
                  bulkNotificationData.schedulerStatus
                }}</span>
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                Status :
                <span class="span-text">{{ bulkNotificationData.status }}</span>
              </h5>
              <h5 class="h5-text">
                Concern:
                <span class="span-text">{{
                  bulkNotificationData && bulkNotificationData.template
                    ? bulkNotificationData.template.concern
                    : ""
                }}</span>
              </h5>
              <h5 class="h5-text">
                Name:
                <span class="span-text">{{
                  bulkNotificationData && bulkNotificationData.template
                    ? bulkNotificationData.template.name
                    : ""
                }}</span>
              </h5>
            </div>
          </b-col>
          <b-col md="4">
            <div class="mx-3">
              <h5 class="h5-text">
                Notification Pending :
                <span class="span-text">{{
                  (bulkNotificationData &&
                    bulkNotificationData.jobStatus &&
                    bulkNotificationData.jobStatus.pending) ||
                  ""
                }}</span>
              </h5>
              <h5 class="h5-text">
                Notification Success :
                <span class="span-text">{{
                  (bulkNotificationData &&
                    bulkNotificationData.jobStatus &&
                    bulkNotificationData.jobStatus.success) ||
                  ""
                }}</span>
              </h5>
              <h5 class="h5-text">
                Notification Failed :
                <span class="span-text">{{
                  (bulkNotificationData &&
                    bulkNotificationData.jobStatus &&
                    bulkNotificationData.jobStatus.failed) ||
                  ""
                }}</span>
              </h5>
            </div>
          </b-col>
          <b-col md="12">
            <div class="mx-3">
              <h5 class="h5-text d-flex">
                Body:
                <span class="span-text ml-2">{{
                  bulkNotificationData && bulkNotificationData.template
                    ? bulkNotificationData.template.body
                    : ""
                }}</span>
              </h5>
            </div>
          </b-col>
        </b-row>
        <div
          class="text-center mb-5 mt-2 p-4"
          v-if="bulkNotificationData.status === 'PENDING'"
        >
          <button
            type="button"
            class="btn btn-lg btn-outline-danger mr-3 w-25"
            @click="approvalStatus(bulkNotificationData._id, 'REJECTED')"
          >
            REJECT
          </button>
          <button
            type="button"
            class="btn btn-lg btn-outline-success ml-3 w-25"
            @click="approvalStatus(bulkNotificationData._id, 'APPROVED')"
          >
            APPROVE
          </button>
        </div>
        <div class="text-center mb-5 mt-2" v-else>
          <button
            type="button"
            class="btn btn-lg btn-outline-primary mr-3 w-25"
            :disabled="true"
          >
            {{ bulkNotificationData.status }}
          </button>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import ComponentHeader from "@/components/componentHeader";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import currentUser from "@/mixins/currentUser";

export default {
  name: "approvalNotificationDetails",
  components: {
    ComponentHeader,
  },
  data() {
    return {
      isloading: false,
      small: false,
      fixed: false,
      bordered: true,
      striped: false,
      criteriaColumns: [
        {
          key: "field",
          label: "Field",
        },
        {
          key: "filter",
          label: "Filter",
          sortable: true,
        },
        {
          key: "value.value",
          label: "Value",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      GetFetchBulkNotificationList:
        "approvalNotificationBulk/GetFetchBulkNotificationList",
      bulkNotificationData:
        "approvalNotificationBulk/GetFetchBulkNotificationDetails",
    }),
    approvalNotificationList() {
      return this.GetFetchBulkNotificationList;
    },
    approvalNotificationFilter() {
      const allFilter = this.bulkNotificationData?.criteria?.filterBy?.map(
        (criteria) => {
          if (criteria.filter !== "date") {
            let showData = {
              value: criteria.data,
              field: criteria.field,
              filter: criteria.filter,
            };
            return showData;
          } else {
            let showData = {
              value: { value: `${criteria.data.gte} To ${criteria.data.lte}` },
              field: criteria.field,
              filter: criteria.filter,
            };
            return showData;
          }
        }
      );
      return allFilter;
    },
  },

  methods: {
    async approvalStatus(id, status) {
      let payload = {
        id: id,
        status: status,
      };
      await this.$store
        .dispatch("approvalNotificationBulk/updateApprovalNoti", payload)
        .then((data) => {
          if (data.status === 1) {
            this.bulkNotificationData = {};
            this.$swal({
              title: "Success",
              text: `Approval Request ${status}`,
              type: "success",
            });
            this.$router.push("/approvalNotification");
          }
        })
        .catch((e) => {});
    },
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY hh:mm A");
      }
    },
    formateScheduleDate: function (value) {
      if (value) {
        let duration = moment.duration({ hours: 5, minutes: 30 });
        return moment(String(value))
          .subtract(duration)
          .format("DD/MM/YYYY hh:mm A");
      }
    },
  },
  mounted: async function () {
    this.loading = true;
    await this.$store.dispatch(
      "approvalNotificationBulk/fetchBulkNotificationDetails",
      this.$route.params.id
    );
    this.loading = false;
  },
};
</script>

<style scoped>
.card {
  border-width: inherit;
  border-radius: 2px;
  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important;
}

[col-4="image"] {
  background-color: aliceblue !important;
}

[btn-back="primary"] {
  background-color: #727cf5 !important;
  margin: 0px;
  height: 41px;
  color: white;
}
</style>
<style>
.footer-bottons-class {
  text-align: center;
  background: #727cf5 !important;
  margin-left: 40%;
}
.span-text {
  font-size: 15px;
  font-weight: normal;
  line-height: 24px;
}
.h5-text {
  font-size: 15px;
  line-height: 17px;
}
</style>
>
